<template>
  <div class="flex mx-2">
    <wui-btn
      variant="neut"
      state="alpha"
      :size="24"
      data-test="schedule-button"
      :prepend-icon="enabled ? 'calendarM' : 'plusAddM'"
      icon
      @click="showScheduleDialog"
    />
    <wui-btn
      v-if="enabled"
      variant="negative"
      state="alpha"
      :size="24"
      icon
      prepend-icon="closeRegularMdM"
      @click="emit('removeSchedule')"
    />
  </div>
</template>
<script setup lang="ts">
import { WuiBtn, WuiScheduleDialog, TimetableTemplate, PermanentSchedule, ScheduleItem, useDialog } from '@wui/common-library'
import { storeToRefs } from 'pinia'
import { computed, ref, watch, Ref } from 'vue'

import { BlackWhiteListEntitySchedule } from '@/entities/black-white-list'
import { useStoreSettingsTimetable } from '@/entities/forwarding'

const props = defineProps<{
  modelValue?: BlackWhiteListEntitySchedule
}>()

const emit = defineEmits<{
  (event: 'update:modelValue', value: BlackWhiteListEntitySchedule): void
  (event: 'removeSchedule'): void
}>()

const innerValue = ref<BlackWhiteListEntitySchedule>(JSON.parse(JSON.stringify(props.modelValue ?? { permanentSchedule: undefined, specialScheduleItems: [] })))
const permanentSchedule = computed<PermanentSchedule>(() => innerValue.value.permanentSchedule ?? { items: [], template: '' })
const specialScheduleItems = computed<Array<ScheduleItem>>(() => innerValue.value.specialScheduleItems ?? [])
const { templates }: { templates: Ref<TimetableTemplate[]> } = storeToRefs(useStoreSettingsTimetable())

const enabled = computed(() => {
  const hasPermanentSchedule = !!innerValue.value.permanentSchedule?.items.map(({ schedule }) => schedule.length > 0).find((item) => !!item)
  const hasSpecialSchedule = !!innerValue.value.specialScheduleItems?.length
  return hasPermanentSchedule || hasSpecialSchedule
})

const showScheduleDialog = async () => {
  const { showDialog } = useDialog<BlackWhiteListEntitySchedule | undefined>()
  const onSaveData = await showDialog(WuiScheduleDialog, {
    hasOverlay: true,
    isNewSchedule: true,
    templates: templates.value,
    activePermanentSchedule: permanentSchedule.value,
    activeSpecialSchedule: specialScheduleItems.value,
  })

  if (onSaveData) {
    emit('update:modelValue', onSaveData)
  }
}

watch(
  () => props.modelValue,
  () => {
    innerValue.value = JSON.parse(JSON.stringify(props.modelValue ?? { permanentSchedule: undefined, specialScheduleItems: [] }))
  },
  { deep: true },
)
</script>
